












import { Component, Prop, Vue } from "vue-property-decorator";
import SecurityService from "../services/SecurityService";

@Component
export default class Sidebar extends Vue {
  created() {
    const authUser = SecurityService.getAuthUser();
    if (authUser.role === "ADMIN") {
      this.menus.push({
        label: "Admin User",
        path: "/admin-user"
      });
    }
  }

  menus: Array<object> = [
    {
      label: "Home",
      path: "/"
    },
    {
      label: "Location",
      path: "/location"
    },
    {
      label: "Holiday",
      path: "/holiday"
    }
  ];
}
